
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useNavigation = () => {
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    {
      name: "SOLUTIONS",
      href: "#",
      dropdown: [
        { name: "For Restaurants", href: "/restaurants" },
        { name: "For Customers", href: "/customers" },
        { name: "For Restaurant Staff", href: "/restaurant-staff" },
        { name: "For Enterprises", href: "/enterprise" }
      ]
    },
    {
      name: "HOW IT WORKS",
      href: "#how-it-works"
    },
    {
      name: "PRODUCTS",
      href: "#",
      dropdown: [
        { name: "AI Virtual Assistant", href: "/products/virtual-assistant" },
        { name: "AI Virtual Host", href: "/products/virtual-host" }
      ]
    },
    {
      name: "RESOURCES",
      href: "#",
      dropdown: [
        { name: "Case Studies", href: "/case-studies" },
        { name: "Blog", href: "/blog" },
        { name: "About Us", href: "/about" },
        { name: "FAQ", href: "/faq" },
        { name: "Contact Us", href: "/contact" }
      ]
    }
  ];

  useEffect(() => {
    setMobileMenuOpen(false);
    setActiveDropdown(null);
    setShowUserDropdown(false);
  }, [location.pathname]);

  return {
    navLinks,
    activeDropdown,
    setActiveDropdown,
    showUserDropdown,
    setShowUserDropdown,
    mobileMenuOpen,
    setMobileMenuOpen
  };
};
